import React from "react";
import Tab from "olive-react-myoneui/lib/Tab";
import Accordion from "olive-react-myoneui/lib/Accordion";
import CoursePlaySlot from "./CoursePlaySlot";

function CourseAccordion({className}) {
  return (
    <div className={`${className || ""} tab-course-contents course-accordion-wrapper curriculum p-3`} >
      <span className="course-short-info lg-short-info-none">2 Lectures • 6 min</span>
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0" className="mb-3">
        <Accordion.Header>
          <span>Up and running with python</span>
          <span className="course-short-info sm-short-info-none">2 Lectures • 6 min</span>
        </Accordion.Header>
        <Accordion.Body>
          <CoursePlaySlot className="course-details mb-3" courseTitle="Random Module - Shuffle and Choice" courseTime="04:08" />
          <CoursePlaySlot className="course-details mb-2" courseTitle="Up and Down Functions" courseTime="05:36" />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2" className="mb-3">
        <Accordion.Header>
          <span>MatPlotLib - Charts, plots and 3D figures</span>
          <span className="course-short-info sm-short-info-none">8 Lectures • 9 min</span>
        </Accordion.Header>
        <Accordion.Body>
          <CoursePlaySlot className="course-details mb-3" courseTitle="Random Module - Shuffle and Choice" courseTime="04:08" />
          <CoursePlaySlot className="course-details mb-2" courseTitle="Up and Down Functions" courseTime="05:36" />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>
          <span>Classes (Object oriented programming)</span>
          <span className="course-short-info sm-short-info-none">5 Lectures • 20 min</span>
        </Accordion.Header>
        <Accordion.Body>
          <CoursePlaySlot className="course-details mb-3" courseTitle="Random Module - Shuffle and Choice" courseTime="04:08" />
          <CoursePlaySlot className="course-details mb-2" courseTitle="Up and Down Functions" courseTime="05:36" />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  </div>
  )
}

export default CourseAccordion;
